const marquees = [...document.querySelectorAll('.banner-tags')];
marquees.forEach((marquee) => {
  marquee.innerHTML = marquee.innerHTML.repeat(5);
  marquee.i = 0;
  marquee.step = 2;
  marquee.width = marquee.clientWidth + 1;
  marquee.style.position = '';
  marquee.innerHTML = `${marquee.innerHTML}`.repeat(5);
});

requestAnimationFrame(move);

function move() {
  marquees.forEach((marquee) => {
    marquee.style.marginLeft = `-${marquee.i}px`;
    marquee.i = marquee.i < marquee.width ? marquee.i + marquee.step : 1;
  });

  requestAnimationFrame(move);
}

function headerResizeListener() {
  let headerAnnouncementOutput = document.querySelector(".announcement-bar");

  function initializeheaderResize() {
    let getAnnouncementHeight = headerAnnouncementOutput.offsetHeight;
    document.documentElement.style.setProperty('--header-anouncement-height', `${getAnnouncementHeight}px`);
  }

  // Initialize on page load
  initializeheaderResize();

  // Reinitialize on window resize
  window.addEventListener("resize", initializeheaderResize);
}

headerResizeListener();

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".flora-ingredient-item");

  items.forEach((item) => {
    item.addEventListener("click", (event) => {
      if (event.target.closest(".flora-ingredient-text-close")) {
        item.classList.remove("active");
        return;
      }

      items.forEach((el) => el.classList.remove("active"));
      item.classList.add("active");
    });
  });
});
